export const transition = {
  // duration: 0.8,
  // type: 'spring',
  // damping: 30,
  // stiffness: 120,
  type: 'tween',
  duration: 1.5,
  bounce: 0,
};
